import { mapGetters, mapActions } from 'vuex'
import ProductModule, { MODULE_NAME } from './index'

const ProductMixin = {
  namespaced: ProductModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(ProductModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(ProductModule.actions)) }
}

export default ProductMixin



// WEBPACK FOOTER //
// ./src/store/module/product/mixin.js